<template>
    <Layout>
      <div class="row">
        <div class="col-12">
                <div class="row">
                  <div class="col-md-3">
                    <div class="card">
                    <div class="card-header bg-primary rounded-1 text-white">{{ service }}</div>
                    <div class="card-body p-2">
                      <div class=" mb-2 d-flex justify-content-between">
                        <img class="img-rounded" src="@/assets/images/sick.png" height="70px" />
                        <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
                      </div>
                      <span v-if="patientspinner==false">
                      <table v-for="item in patients" :key="item.id" class="table">
                      <tr><td>Full Name </td><td> <b class="text-primary h7">{{ item.name }} </b></td></tr>
                      <tr><td>Gender </td><td> <span class="text-primary h7">{{ item.gender }} </span></td></tr>
                      <tr><td> Telephone </td><td> <span class="text-primary h7">0{{ item.telephone }} </span></td></tr>
                      <tr><td> Date of Birth </td><td> <span class="text-primary h7">{{ item.date_of_birth }} </span></td></tr>
                      <tr><td> Email Address </td><td> <span class="text-primary h7">{{ item.email }} </span></td></tr>
                      <tr><td> Address </td><td> <span class="text-primary h7">{{ item.address }} </span></td></tr>
                      <tr><td> Nationality </td><td> <span class="text-primary h7">{{ item.nationality }} </span></td></tr>
                      </table>
                        </span>
                      <span v-else>
                        <i class="fas fa-spinner fa-3x p-5 text-primary fa-spin"></i> 
                      </span>
                    </div>
                    </div>
                  </div>
                  <div class="col-md-9">
                        <div class="card">
                          <div class="card-body">
                              <form @submit.prevent="addResult">
                                <label class="mt-2">Results</label>
                                <tinymce id="d4" v-model="result"></tinymce>
                                <label>Date Recorded</label>
                                <input v-model="daterecorded" type="date" class="form-control" />
                                <label>Attact Files</label>
                                <input type="file" class="form-control" v-on:change="onFileChange">
                                <div class="form-group d-flex justify-content-end mt-3">
                                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
                                </div>
                              </form>
                          </div>
                        </div>
                  </div>
                </div>
        </div>
      </div>
     
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  
  export default {
    page: {
      title: "Patient Treatment",
      meta: [{name: "description",content: appConfig.description,},],
    },
    components: {
      Layout,
    },
    data() {
      return {
        title: "Patient Treatment",
        items: [{text: "Dashboard",to: "/",},{text: "Patients",active: true,},],
        patients:[],
        patientspinner:true,
        patientid:'',
        visitid:'',
        service:'',
        service_id:'',
        result:'',
        daterecorded:new Date().toLocaleDateString('fr-CA'),
        files:'',
        treatmentresults:[],
      };
    },
    computed: {
    },
    created() {
      this.fetchInfo();
    },
    methods: {
    onFileChange(e){
      this.files = e.target.files[0];
    },
      async fetchInfo(){
        this.id=this.$route.query.id;
        let url = `/visitinfo/${this.id}`;
        await axios.get(url).then((response) => {
          this.patientid = response.data.visits[0].patient.patient_id;
          this.visitid = response.data.visits[0].visit_id;
          this.service = response.data.visits[0].service_name.name;
          this.service_id = response.data.visits[0].service_name.id;
          this.showpatient();
        });
      },
      async showpatient(){
        let url = `/patientprofile/${this.patientid}`;
        await axios.get(url).then((response) => {
          this.patients = response.data.patients;
          this.patientspinner=false;
        });
      },
      async addResult(){ 
    const config = { headers: { 'content-type': 'multipart/form-data' } };
    let formData = new FormData();
    formData.append("patient", this.patientid);
    formData.append("visit_id", this.visitid);
    formData.append("test", this.service_id);
    formData.append("result", this.result);
    formData.append("daterecorded", this.daterecorded);
    formData.append("file", this.files);
    let url = "/addpatiettestresults";
    await axios.post(url, formData, config).then((response) => {
      if (response.status == 200) {
        this.visit_id="";
        this.patient_name="";
        this.testid="";
        this.result="";
        this.daterecorded="";
        this.files="";
        this.$router.push({ path: 'testresultreports' });
      }
    });
    },
    },
  };
  </script>